import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0% {
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0);
      -webkit-animation-timing-function: ease-out;
      animation-timing-function: ease-out
    }

    25% {
      -webkit-transform: translate(0px, 6px);
      transform: translate(0px, 6px);
      -webkit-animation-timing-function: ease-in-out;
      animation-timing-function: ease-in-out
    }

    50% {
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0);
      -webkit-animation-timing-function: ease-out;
      animation-timing-function: ease-out
    }

    75% {
      -webkit-transform: translate(0px, 6px);
      transform: translate(0px, 6px);
      -webkit-animation-timing-function: ease-in-out;
      animation-timing-function: ease-in-out
    }

    100% {
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0)
    }
  }
`;

const fadeIn = keyframes`
 from {
    top:-300px;
    opacity:0;
  } 
 to {
    top:0;
    opacity:1
 }
`;

export const MarginBox = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  /*flex-direction: column;*/
  justify-content: center;

  @media screen and (max-width: 992px) {
    display: ${({ showAsStackInMobile }) => showAsStackInMobile == "true" ? "block" : "flex"};
    flex-wrap: wrap;
  }

  .ease-out {
    /*position: relative;*/
    animation: ${fadeIn} 0.2s;
  }
`;

export const BigGreenBox = styled.div`
  display: flex;
  width: 80vw;
  flex-direction: column;
  margin: 20px 0 20px 0;
  border-radius: 20px;
  background-color: #6CB93D;

  @media screen and (max-width: 992px) {
    width: 100%;
    /*margin: 0;*/
  }

  h1 {
    text-align: center;
    font-size: 38px;
    font-weight: 600;

    img {
        height: 38px;
        vertical-align: bottom;
    }

    @media screen and (max-width: 992px) {
        font-size: 18px;    

        img {
            height: 20px;
        }
    }
  }
    
  .blue-highlight:hover {
        cursor: pointer;
        color: #1B2555;
        path {
            fill: #1B2555 !important;
        }
  }

  svg.bounce {
    align-self: center;
    animation: ${bounce} 2s linear infinite;
    /*margin-top: 52px;*/    
    margin-bottom: 33px;

    @media screen and (max-width: 992px) {
        margin-top: 30px;    
        margin-bottom: 30px;
    }
  }

  svg.grid-icon {
    align-self: center;
    width: 120px;
    height: 120px;
    margin-bottom: 35px;
    
    @media screen and (max-width: 992px) {
        width: 70px;
        height: 70px;
    }
  }

  svg.grid-icon-large {
    align-self: center;
    width: 185px;
    height: 120px;
    margin-bottom: 35px;
    
    @media screen and (max-width: 992px) {
        width: 105px;
        height: 70px;
    }
  }

  span.know-more {
    align-self: center;
    width: fit-content;
    font-size: 20px;
    margin-top: 18px;
    margin-bottom: 12px; 
    text-decoration: underline;
  }

  .description {
    text-align: center;
    font-size: 24px;
    margin: 20px 69px 20px 69px;

    span {
        font-size: 24px;
        color: #1B2555;
        font-weight: 600;

        @media screen and (max-width: 992px) {
            font-size: 14px;    
        }
    } 

    @media screen and (max-width: 992px) {
        font-size: 14px;    
    }
  }

  .mg {
    margin: 20px 69px 0 69px;

    p {
        text-align: center;
        font-size: 20px;
        margin-bottom: 66px;
    }

    span {
        font-size: 20px;
        color: #1B2555;
        font-weight: 600;
    }

    @media screen and (max-width: 992px) {
        display: none;
    }
  }

 .mgm {
    display: none;

    @media screen and (max-width: 992px) {
        display: block;
        margin: 20px 39px 0 39px;
        min-height: 550px;

        p {
            text-align: center;
            font-size: 18px;
            margin-bottom: 66px;
        }

        span {
            font-size: 18px;
            color: #1B2555;
            font-weight: 600;
        }
    }
  }
`;

export const ContentBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 60px 0 60px 0;
  /*max-width: 604px;*/
  /*max-width: 850px;*/

  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    width: 100%;
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    width: 100%;
  }
`;

export const ContentCenterBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  /*margin: 60px 0 60px 0;*/
  margin: 20vh 0 20vh 0;
  /*max-width: 604px;*/
  max-width: 850px;
  justify-content: center;

  @media screen and (max-width: 992px) {
    order: 1;
    display: flex;
    width: 100%;
    margin: 30px 0 0 0;
  }
`;

export const OtherContentBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 60px 0 0 0;
  /*max-width: 604px;*/
  max-width: 850px;

  @media screen and (max-width: 992px) {
    width: 100%;
    margin: 30px 0 0 0;
  }
`;

export const SubContentBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  flex-direction: column;
  margin: 0 0 0 0;
  max-width: 604px;
  align-items: center;

  @media screen and (max-width: 992px) {
    width: 100%;
    margin: 0;
  }
`;

export const ImgBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  margin: 60px 0 60px 0;
  justify-content: space-between;
  
  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "block" : "none"};
    /*margin: 0;*/
  }

  @media screen and (max-width: 640px) {
    display: none;
  }
`;

export const ImgMobileBox = styled.div`
  display: none;
  margin: 60px 0 60px 0;
  justify-content: space-between;
  
  @media screen and (max-width: 992px) {
    display: block;
    margin: 30px 0 30px 0;
    width: 100%;
  }
`;

export const ImageBox = styled.div`
  display: flex;
  width: ${({ size }) => size};
  /*margin: 0 auto;*/
  /*margin: 60px 0 60px 0;*/
  justify-content: space-between;
  
  @media screen and (max-width: 992px) {
    display: ${({ showInMobile }) => showInMobile == "true" ? "flex" : "none"};
    order: 2;
    width: 100%;
    margin: 0 0 30px 0;
  }

  @media screen and (max-width: 640px) {
    /*display: none;*/
  }
`;

export const Image = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 60vh;
  background-image: url(${({ imageSrc }) => imageSrc});
  /*background-size: 100% 100%;*/
  background-size: contain;
  background-repeat: no-repeat;

  @media screen and (max-width: 1024px) {
    min-height: 40vh;
  }
  
  @media screen and (max-width: 992px) {
    /*min-height: 30vh;
    min-width: 45vw;*/
    min-height: 50vw;
    min-width: 80vw;
  }
`;

export const BigImage = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 42vh;
  background-image: url(${({ imageSrc }) => imageSrc});
  /*background-size: cover;*/
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 55% center;

  @media screen and (max-width: 1024px) {
    min-height: 40vh;
  }
  
  @media screen and (max-width: 992px) {
    min-height: 50vh;
    min-width: 80vw;
  }

  @media screen and (max-width: 640px) {
    min-height: 25vh;
    min-width: 40vw;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  margin : 0px 10px 20px 0px;

  h1.first {
    font-size: 36px;
    margin-bottom: 24px;
    color: #abc6de;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }

  h1.center {
    font-size: 32px;
    margin-bottom: 24px;
    color: #1B2555;
    text-align: center;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }

  h1 {
    /*font-size: 42px;*/
    font-size: 2.5vw;
    font-weight: bold;
    margin-bottom: 24px;
    color: #1B2555;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }

  p.green {
    font-size: 16px;
    line-height: 170%;
    color: #6AB644;
    font-weight: 500;

    @media screen and (max-width: 992px) {
      font-weight: 500;
    }
  }

  p {
    /*font-size: 22px;*/
    font-size: 1.25vw;
    line-height: 170%;
    color: #585858;
    font-weight: 500;

    @media screen and (max-width: 992px) {
      font-size: 4.25vw;
    }
  }

  span.first {
    font-size: 36px;
    color: #69b643;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }

  span {
    font-size: 32px;
    color: #69b643;

    @media screen and (max-width: 992px) {
      font-size: 24px;
    }
  }
`;
export const DesktopButton = styled.div`
  display: flex;

  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const MobileButton = styled.div`
  display: none;

  @media screen and (max-width: 992px) {
    display: flex;
  }
`;

export const Paragraph = styled.p`
  font-size: 16px;
  color: ${({ color }) => color};
  margin: auto auto;
  max-width: 756px;
  font-weight: 500;
`;

export const Title = styled.h1`
  text-align: center;
  margin: ${({ margin }) => margin};
  font-size: 25px;
  color: #1b2555;
  font-weight: 700;

  @media screen and (max-width: 992px) {
    font-size: 18px;
  }
`;

export const TitleLabel = styled.h3`
  text-align: ${({ align }) => align};
  margin: ${({ margin }) => margin};
  line-height: 200%;
  font-size: 20px;
  color: #585858;
  font-weight: 600;
  max-width: 536px;

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

export const SubTitle = styled.h1`
  text-align: center;
  margin: ${({ margin }) => margin};
  font-size: 16px;
  color: #1b2555;
  font-weight: 700;
  max-width: 756px;

  a {
    font-size: 16px;
    color: #1b2555;
    font-weight: 700;
    text-decoration: underline;
  }

  @media screen and (max-width: 992px) {
    font-size: 16px;
  }
`;
export const ListMember = styled.li`
  font-size: 16px;
  color: ${({ color }) => color};
  margin: auto auto;
  max-width: 671px;
  font-weight: 500;
`;

export const StripLeft = styled.div`
  display: flex;
  width: 1px;
  height: 120px;
  background-color: #69b643;
  margin: 0px 0 0 25vw;

  @media screen and (max-width: 992px) {
    height: 50px;
    /*margin: -82px 0 0 40vw;*/
  }
`;

export const StripCenter = styled.div`
  display: flex;
  width: 1px;
  height: 256px;
  background-color: #69b643;
  margin: 84px 0 0 50%;

  @media screen and (max-width: 992px) {
    height: 128px;
    margin: 30px 0 0 50%;
  }
`;

export const StripRight = styled.div`
  display: flex;
  width: 1px;
  height: 120px;
  background-color: #69b643;
  margin: 0px 0 0 65vw;

  @media screen and (max-width: 992px) {
    height: 50px;
    /*margin: -82px 0 0 40vw;*/
  }
`;